<section class="vehicle-page">
  <div class="container-fluid">
    <p class="vehicle-crumb">
      Home / Vehicles / <span>{{ vehicleName }}</span>
    </p>

    <div class="vehicle-layout">
      <!-- Gallery -->
      <div class="vehicle-gallery">
        <app-item-slider [slides]="slides"></app-item-slider>
      </div>

      <!-- Buy box -->
      <div class="vehicle-buybox">
        <div class="vehicle-buybox__heading">
          <span *ngIf="vehicleInfo['type']" class="vehicle-buybox__ribbon">
            {{ tags[vehicleInfo["type"]]["tagName"] }}
          </span>
          <h1 class="vehicle-buybox__title">{{ vehicleName }}</h1>
        </div>
        <p class="vehicle-buybox__location" *ngIf="location">
          <ion-icon name="location-outline"></ion-icon>
          {{ location }}
        </p>

        <div class="vehicle-buybox__price" *ngIf="priceDisplay">
          <span class="vehicle-buybox__price-label">Listed Price</span>

          <div class="vehicle-buybox__price-value-wrapper">
            <span class="vehicle-buybox__price-value">&#65020;</span>
            <span class="vehicle-buybox__price-value"> {{ priceDisplay }}</span>
          </div>
        </div>

        <div
          class="vehicle-buybox__status"
          *ngIf="vehicleInfo['type'] === '2' || vehicleInfo['type'] === '3'"
        >
          <span class="vehicle-buybox__status-label">
            <span class="dot" [class.dot--on]="vehicleStatus"></span>
            {{ vehicleStatus ? "Active listing" : "Inactive listing" }}
          </span>

          <button
            type="button"
            [ladda]="laddaLoading"
            class="toggle-btn toggle-btn--on"
            *ngIf="!vehicleStatus"
            (click)="updateVehicleStatus(productId, !vehicleStatus)"
          >
            Turn On
          </button>

          <button
            type="button"
            [ladda]="laddaLoading"
            class="toggle-btn toggle-btn--off"
            *ngIf="vehicleStatus"
            (click)="updateVehicleStatus(productId, !vehicleStatus)"
          >
            Turn Off
          </button>
        </div>

        <!-- Highlight chips: fills the previously-empty column with the
             most decision-relevant facts, pulled straight from description_data -->

        <div class="vehicle-buybox__chips">
          <ng-container *ngFor="let field of highlightFields">
            <div class="chip" *ngIf="vehicleInfo['description_data']?.[field]">
              <span class="chip__label">{{ field }}</span>
              <span class="chip__value">{{
                vehicleInfo["description_data"][field]
              }}</span>
            </div>
          </ng-container>
        </div>
        <div
          class="d-flex align-items-center justify-content-between mt-4"
          *ngIf="vehicleInfo['type'] !== '4'"
        >
          <p class="m-0 mr-2">
            Vehicle Buy Status:
            <span class="font-weight-bold text-capitalize">{{
              vehicleBuyStatus
            }}</span>
          </p>
          <button
            type="button"
            class="btn sold-btn"
            (click)="toggleSold()"
            [disabled]="vehicleBuyStatus === 'sold'"
          >
            <ion-icon name="pricetags-outline" size="default"></ion-icon>
            Sold
          </button>
        </div>
      </div>
    </div>

    <!-- Test Drive Video / 360 View: two cards, side by side -->
    <div class="media-cards">
      <div class="media-card">
        <div class="media-card__icon">
          <ion-icon name="videocam-outline"></ion-icon>
        </div>
        <div class="media-card__body">
          <span class="media-card__title">Test Drive Video</span>
          <span class="media-card__subtitle">See it in motion</span>
        </div>
        <button
          type="button"
          class="media-card__action"
          *ngIf="vehicleInfo['description_data']?.['Test Drive Video']; else noTestDrive"
          (click)="
            openTestDriveModal(
              modalTemplate,
              vehicleInfo['description_data']['Test Drive Video']
            )
          "
        >
          <ion-icon name="play-circle-outline"></ion-icon>
          View
        </button>
        <ng-template #noTestDrive>
          <span class="media-card__empty">Not available</span>
        </ng-template>
      </div>

      <div class="media-card">
        <div class="media-card__icon">
          <ion-icon name="sync-outline"></ion-icon>
        </div>
        <div class="media-card__body">
          <span class="media-card__title">Vehicle 360° View</span>
          <span class="media-card__subtitle">Look all the way around</span>
        </div>
        <button
          type="button"
          class="media-card__action"
          *ngIf="vehicleInfo['description_data']?.['Vehicle 360 Link']; else no360"
          (click)="
            open360ViewModal(
              modalTemplate,
              vehicleInfo['description_data']['Vehicle 360 Link']
            )
          "
        >
          <ion-icon name="play-circle-outline"></ion-icon>
          View
        </button>
        <ng-template #no360>
          <span class="media-card__empty">Not available</span>
        </ng-template>
      </div>
    </div>

    <!-- Window-sticker style specification sheet -->
    <div class="sticker">
      <div class="sticker__head">
        <h5><span class="sticker__mark"></span>Vehicle Specification Sheet</h5>
      </div>

      <div class="sticker__body">
        <div class="spec-list">
          <ng-container
            *ngFor="let info of vehicleInfo['description_data'] | keyvalue"
          >
            <!-- Test Drive Video / Vehicle 360 Link now live in the buy box
                 above (with a "Not available" state), so skip them here to
                 avoid showing the same field twice. -->
            <div
              class="spec-row"
              *ngIf="
                info.value &&
                info.key !== 'Test Drive Video' &&
                info.key !== 'Vehicle 360 Link'
              "
            >
              <span class="spec-row__label">{{ info.key }}</span>
              <span class="spec-row__leader"></span>
              <span class="spec-row__value">{{ info.value }}</span>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Additional info -->
      <ng-container *ngIf="vehicleOtherInfo.length">
        <div class="sticker__divider">Additional Information</div>
        <div class="sticker__body">
          <div class="spec-list">
            <div class="spec-row" *ngFor="let info of vehicleOtherInfo">
              <span class="spec-row__label">{{ Object.keys(info)[0] }}</span>
              <span class="spec-row__leader"></span>
              <span class="spec-row__value">{{ Object.values(info)[0] }}</span>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>

<app-loader *ngIf="loading"></app-loader>

<ng-template #modalTemplate>
  <div class="modal-header">
    <ng-container *ngIf="switch === 'testDrive'">
      <h4 class="modal-title pull-left">{{ vehicleName }} Test Drive Video</h4>
    </ng-container>
    <ng-container *ngIf="switch === '360View'">
      <h4 class="modal-title pull-left">{{ vehicleName }} 360&deg; View</h4>
    </ng-container>
    <button
      type="button"
      class="btn-close close pull-right"
      aria-label="Close"
      (click)="modalRef?.hide()"
    >
      <span aria-hidden="true" class="visually-hidden">
        <ion-icon name="close-outline"></ion-icon>
      </span>
    </button>
  </div>
  <div class="modal-body">
    <iframe
      id="spins-data"
      style="width: -webkit-fill-available; min-height: 60vh; border: none"
    ></iframe>
  </div>
</ng-template>

<app-confirm-sold-modal
  [isOpen]="showConfirm"
  [actionMessage]="'Do you want to mark these vehicle as sold?'"
  [actionInProgress]="deleting"
  [autoConfirmSeconds]="10"
  [fromVehicle]="true"
  [confirmLable]="'Mark as Sold'"
  (confirmed)="onConfirmed()"
  (cancelled)="onCancelled()"
></app-confirm-sold-modal>
